<template>
  <div>
    <div class="dropdown" @click="showDropdown(rowData)" :class="{'is-active': rowData === selected_dropdown}">
      <div class="dropdown-trigger">
        <button class="button is-primary" aria-haspopup="true" aria-controls="dropdown-menu">
          <span class="icon is-small">
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <slot></slot>
          <router-link v-show="btnDetail" class="dropdown-item" :to="detail_link">Detail</router-link>
          <a v-show="btnShowHide" class="dropdown-item" v-text="btn_show_hide_label" @click="showHideData"></a>
          <router-link v-show="btnUpdate" class="dropdown-item" :to="update_link">Update</router-link>
          <a v-show="btnDelete" class="dropdown-item" @click="getModalConfirmation('Delete Data', 'Are you sure want to delete this?', 'delete_data')">Delete</a>
          <slot name="bottom"></slot>
        </div>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      detail_link: '',
      update_link: '',
      selected_dropdown: '',
      btn_show_hide_label: ''
    }
  },
  props: [
    'modulPath',
    'rowData',
    'btnDetail',
    'btnShowHide',
    'btnUpdate',
    'btnDelete'
  ],
  created () {
    this.setContraShowHideLabel()
    this.detail_link = this.modulPath + 'detail/' + this.rowData.id
    this.update_link = this.modulPath + 'update/' + this.rowData.id
  },
  methods: {
    showDropdown (passdata) {
      if (this.selected_dropdown !== '') {
        this.selected_dropdown = ''
      } else {
        this.selected_dropdown = passdata
      }
    },
    showHideData () {
      var tempShowValue = 0
      if (this.rowData.show_value === 0) {
        tempShowValue = 1
      }
      var passData = {
        id: this.rowData.id,
        data: tempShowValue
      }
      this.$geb.emit({
        id: 'show-hide-data',
        event_data: passData
      })
      this.rowData.show_value = tempShowValue
      this.setShowHideLabel()
      this.setContraShowHideLabel()
    },
    executeModalAction (confirmData) {
      if (confirmData.label === 'delete_data') {
        if (confirmData.flag === true) {
          this.$geb.emit({
            id: 'delete-data',
            event_data: this.rowData.id
          })
        }
      }

      this.clearModalConfirmationData()
    },
    setShowHideLabel () {
      if (this.rowData.show_value === 1) {
        this.rowData.show = 'Show'
      } else {
        this.rowData.show = 'Hide'
      }
    },
    setContraShowHideLabel () {
      if (this.rowData.show_value === 0) {
        this.btn_show_hide_label = 'Show'
      } else {
        this.btn_show_hide_label = 'Hide'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/tablebuttondropdown.vue